export interface APIResponse {
    status: string;
    code: number;
}

export enum ColumnType {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Date = 'date',
  Template = 'template'
}

export enum StringOperator {
  Equals = 'equals',
  StartsWith = 'startsWith',
  EndsWith = 'endsWith',
  Contains = 'contains'
}

export enum NumberOperator {
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  LessThanOrEqual = 'lessThanOrEqual'
}

export enum BooleanOperator {
  Equals = 'equals',
  NotEquals = 'notEquals',
  IsTrue = 'isTrue',
  IsFalse = 'isFalse'
}

export enum DateOperator {
  Equals = 'equals',
  Before = 'before',
  After = 'after',
  Between = 'between'
}

export interface FilterCondition {
  columnName: string;
  columnType: ColumnType;
  operator: StringOperator | NumberOperator | BooleanOperator | DateOperator;
  value: string | number | boolean | Date;
  endValue?: Date; // for date range (between operator)
}

export interface FilterConfig {
  conditions: FilterCondition[];
  operator: 'AND' | 'OR';
}

export interface LogPayload {
  page?: string;
  filters?: {
    dateRange?: string;
    meterType?: string;
    showOnlyActive?: boolean;
    [key: string]: any;
  };
  sortBy?: string;
  sortOrder?: string;
  [key: string]: any;
}

export interface LogResponse {
  totalMeters?: number;
  activeConsents?: number;
  pendingRequests?: number;
  loadTime?: string;
  dataSource?: string;
  [key: string]: any;
}

export interface AddLogRequest {
  apiName: string; // 1-255 chars
  source: string; // max 100 chars
  success: boolean;
  payload?: LogPayload | any[] | string | null;
  errorMessage?: string; // max 1000 chars
  apiKey?: string; // max 255 chars
  response?: LogResponse | any[] | string | null;
  userId?: string; // max 100 chars
  ip?: string; // max 45 chars (IPv4/IPv6)
  tracker?: string; // max 255 chars
}

export interface AddLogResponse extends APIResponse {
  data?: {
    logId?: string;
    timestamp?: string;
  };
}
